export default __webpack_public_path__ + "static/media/AAPS_RGB_Strap.56dee5ee.png";